import { useState } from "react";
import { Download, FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "./ui/dropdown-menu";
import { toast } from "sonner";
import { API } from "../App";

const ExportButtons = ({ macroArea, stato, className = "" }) => {
  const [exporting, setExporting] = useState(null);

  const handleExport = async (format) => {
    setExporting(format);
    try {
      const params = new URLSearchParams();
      if (macroArea) params.append("macro_area", macroArea);
      if (stato) params.append("stato", stato);
      
      const url = `${API}/export/orders/${format}?${params.toString()}`;
      
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || "Errore durante l'export");
      }
      
      // Get filename from Content-Disposition header
      const contentDisposition = response.headers.get("Content-Disposition");
      let filename = `ordini_export.${format}`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename=([^;]+)/);
        if (match) filename = match[1];
      }
      
      // Create blob and download
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success(`Export ${format.toUpperCase()} completato!`);
    } catch (error) {
      console.error("Export error:", error);
      toast.error(error.message || "Errore durante l'export");
    } finally {
      setExporting(null);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          className={`gap-2 ${className}`}
          data-testid="export-dropdown-btn"
        >
          {exporting ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <Download className="h-4 w-4" />
          )}
          Esporta
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Formato export</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem 
          onClick={() => handleExport("csv")}
          disabled={exporting}
          className="cursor-pointer"
          data-testid="export-csv-btn"
        >
          <FileText className="h-4 w-4 mr-2 text-green-600" />
          CSV (Excel compatibile)
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleExport("excel")}
          disabled={exporting}
          className="cursor-pointer"
          data-testid="export-excel-btn"
        >
          <FileSpreadsheet className="h-4 w-4 mr-2 text-emerald-600" />
          Excel (.xlsx)
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleExport("pdf")}
          disabled={exporting}
          className="cursor-pointer"
          data-testid="export-pdf-btn"
        >
          <FileText className="h-4 w-4 mr-2 text-red-600" />
          PDF Report
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportButtons;
